function chipWidthsChanged(prev = {}, next = {}) {
  const nextIds = Object.keys(next);
  if (nextIds.length !== Object.keys(prev).length) return true;
  return nextIds.some((id) => prev[id]?.width !== next[id]?.width);
}

function mergeLiveChipWidths(itemWidths = {}, refs = []) {
  const widths = { ...itemWidths };
  refs.forEach((ref) => {
    const node = ref?.current;
    const id = node?.dataset?.id;
    if (!id) return;
    widths[id] = { width: node.clientWidth };
  });
  return widths;
}

export {
  chipWidthsChanged,
  mergeLiveChipWidths,
};
